import React from 'react';

import { CONTENT_DETAIL_KEY } from '../../../../constants/cycleDetail';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';

import { Button } from '../../../../design-system';
import RotateCcwIcon from '../../../../design-system/Icons/RotateCcwIcon';

const FormActionBar = ({
    type,
    status,
    handleReloadFormData,
    handleSaveStageChanges,
    saveChangesButtonState,
}) => {
    const { isDesktop } = useResponsiveBreakpoints();
    const isEditable = !!isDesktop;

    if (!isEditable) return null;

    const withFormActions = !!CONTENT_DETAIL_KEY[type]?.[status];
    if (!withFormActions) return null;

    return (
        <div className="fixed bottom-3 right-2 lg:right-[320px] min-[1800px]:right-[380px] p-2 flex items-center gap-2.5 z-10 bg-white rounded-2">
            <Button
                type="link"
                size="sm"
                text="Undo"
                leadingIcon={RotateCcwIcon}
                onClick={handleReloadFormData}
            />
            <Button
                type="secondary"
                size="sm"
                text="Save"
                state={saveChangesButtonState}
                onClick={handleSaveStageChanges}
            />
        </div>
    );
};

export default FormActionBar;
